import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel } from '@mui/material';
import { addDays, format, isValid, parseISO } from 'date-fns';
import { PickerInput } from '~/components';
import { PickerInputTypeEnum } from '~/components/PickerInput';

const EndDateField = () => {
  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  const endDate = watch('end_date');
  const startDate = watch('start_date');
  const startDateValue = typeof startDate === 'string' ? parseISO(startDate) : startDate;
  const minEndDate =
    startDateValue instanceof Date && isValid(startDateValue)
      ? format(addDays(startDateValue, 1), 'yyyy-MM-dd')
      : format(addDays(new Date(), 1), 'yyyy-MM-dd');

  // Ensure that end date is not earlier than start date on start date change
  useEffect(() => {
    if (!endDate || !startDate) return;

    if (endDate < minEndDate) {
      setValue('end_date', minEndDate, { shouldValidate: true, shouldDirty: true });
    }
  }, [startDate, setValue, endDate]);

  return (
    <Controller
      name="end_date"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          label="END DATE"
          control={
            <PickerInput
              error={!!errors.end_date}
              helperText={errors.end_date?.message as string}
              slotProps={{ htmlInput: { min: minEndDate } }}
              type={PickerInputTypeEnum.DATE}
              {...field}
            />
          }
        />
      )}
    />
  );
};

export default EndDateField;
